import { get } from "lodash-es";
import { GetText } from "./types";

export const resolve = <TOption>(
  opt: TOption | string,
  getText: GetText<TOption>
) => {
  if (typeof opt === "string" || typeof opt === "number") {
    return opt;
  }

  return typeof getText === "function" ? getText(opt) : get(opt, getText);
};
